import type { CustomField, ProductDetails, VisibleVariantOptionInterface } from '~/types/Product'
import type { ProductResponseInterface } from '~/types/market/productBackendTypes'

export const findProductVariant = (product?: ProductResponseInterface, variant?: number) => {
  if (!product) {
    return
  }

  let productDetails: ProductDetails = {
    ...product.default_values,
    name: product.name,
    available_quantity: product.available_quantity,
    is_sold_out: product.is_sold_out,
    media: product.medias.map((media) => media.image),
    item_id: product.item_id,
    price_composition: product.price_composition,
    shipping_methods: product.shipping_methods,
    local_delivery_couriers: product.local_delivery_couriers,
  }

  if (!variant || variant === product.item_id) {
    return productDetails
  }

  const otherVariant = product.other_items.find((product) => product.id === variant)

  if (otherVariant) {
    productDetails = {
      ...productDetails,
      name: otherVariant.name,
      available_quantity: otherVariant.available_quantity,
      is_sold_out: otherVariant.is_sold_out,
      media: [...otherVariant.media].reverse(),
      item_id: otherVariant.id,
      old_price: otherVariant.old_price,
      current_price: otherVariant.current_price,
      price_composition: otherVariant.price_composition,
      shipping_methods: otherVariant.shipping_methods,
      local_delivery_couriers: otherVariant.local_delivery_couriers,
    }
  }

  return productDetails
}

export const getInitialFieldValues = (customFields?: CustomField[], variantId?: number) => {
  const initialValues: { [key: string]: VisibleVariantOptionInterface } = {}

  if (Array.isArray(customFields)) {
    customFields.forEach((customField: CustomField) => {
      const customFieldValues = customField.values

      initialValues[customField.id] = {
        id: null,
        key: '',
        value: '',
        disabled: false,
      }

      const fieldData = customFieldValues.find((value) => value.item_id === variantId) ?? customFieldValues?.[0]

      if (fieldData) {
        const key: string = generateOptionKey(customField.id, fieldData.value)

        initialValues[customField.id] = {
          id: key,
          key,
          value: fieldData.value,
          disabled: false,
        }
      }
    })
  }

  return initialValues
}

export const sortFieldsByCategoryMainFieldId = (
  customFields?: CustomField[],
  mainFieldId?: number | null
): CustomField[] | undefined => {
  if (mainFieldId && customFields) {
    const sortedFields = [...customFields]

    for (let i = 0; i < customFields.length; i++) {
      if (customFields[i].id === mainFieldId) {
        const field = sortedFields.splice(i, 1)
        sortedFields.unshift(field[0])
        break
      }
    }

    return sortedFields
  }

  return customFields
}

export const generateOptionKey = (fieldId: number, optionValue: string): string => {
  return JSON.stringify([fieldId, optionValue])
}
